module.exports = __webpack_public_path__ + "static/media/clerk.13ea79ee.svg";